export default __webpack_public_path__ + "static/7-9e007fd4d60ff1590481ba819dbdd7a7.jpg";